import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './NonLogged.module.scss';
import { handlAuthUserType } from '../../../../reducersAndActions/actions/authAction';
import { useAuth } from '../../../../contexts/auth';
import { Footer } from '../../../common';

const NonLoginHome = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [, dispatch] = useAuth();

  const nonLogedInOptions = [
    { id: 'business', title: 'I am a Business Owner', icon: 'type_business_icon' },
    { id: 'user', title: 'I am a User', icon: 'type_user_icon' },
  ];

  const searchParams = new URLSearchParams(location.search);
  const addQueryParam = (key, value) => {
    searchParams.set(key, value);
    const newUrl = `${location.pathname}?${searchParams.toString()}`;
    navigate(newUrl, { replace: true });
  };

  const handleOptions = async (each) => {
    handlAuthUserType(dispatch, each?.id || '');
    sessionStorage.setItem('landingPageUserType', each?.id);
    addQueryParam('type', each?.id);
  };
  return (
    <div className="hotkeybox_text">
      <div className="typebox_text pt-25">
        <div className="font16 fw600 color111 text_center">Choose type</div>
        <div className="font12 fw500 color777 text_center mt-5">Do not worry! we will help you to solve problem</div>
      </div>
      <ul className="hotkeybox_listgroup pt-40 pl-10 pr-10">
        {nonLogedInOptions.map((each, idx) => (
          <li key={idx} className={`${styles.Contract__ListGroupItem} mb-15`}>
            <div
              aria-label="nonLogedInOptions_click"
              tabIndex={0}
              role="button"
              onKeyDown={() => {}}
              onClick={() => handleOptions(each)}
              className={`${styles.Contract__ListGroupAnchor} whitefill_animate`}
              style={{
                border: '1.5px solid #e7e7e7',
              }}
            >
              <div className={`csicon hotkeybox_icon ${each.icon}`} />
              <div className={`${styles.Contract__ListGroupText} pl-12 pr-20`}>
                <div className="no_login_list font14 fw600 color111">{each.title}</div>
              </div>
            </div>
          </li>
        ))}
      </ul>
      <Footer />
    </div>
  );
};

export default NonLoginHome;
